import React, { useMemo } from "react";
import { ContentCardType } from "../../controller/MasterController";
import { ThemeType } from "../../recoil/theme";
import { contentName } from "../../utils/util";
import StoreCouponContent from "./content/storeCouponContent";

interface AroundStoreProps {
  aroundCardList: ContentCardType[];
  lang: number;
  openVoucher: any;
  theme: ThemeType;
}

const AroundStore = ({
  aroundCardList,
  lang,
  openVoucher,
  theme,
}: AroundStoreProps) => {
  const AroundStore = useMemo(() => {
    return (
      <div className="centerWrap">
        <div className="deliveryTitle">
          <div className="row">
            <h2>{contentName("호텔 주변 맛집 쿠폰", lang)}</h2>
            {theme.around_store && (
              <img
                src={`${process.env.PUBLIC_URL}/knockknock/svg/event/ic_snowman.svg`}
                alt="snowman"
              />
            )}
          </div>
        </div>
        <div className="normalStoreWrap">
          {aroundCardList.map(
            (card: ContentCardType, index: number) =>
              card.content_type === "CARD" && (
                <StoreCouponContent
                  key={index}
                  item={card}
                  navigateCoupon={openVoucher}
                />
              )
          )}
        </div>
      </div>
    );
  }, [aroundCardList, lang]);

  return AroundStore;
};
export default AroundStore;
